import { AutoMap } from "@automapper/classes"
import { PrelevementDTO } from "./prelevement.dto"

export class CanalDTO {
    @AutoMap()
    portee: number = 0
    @AutoMap()
    volumeLiquideInjecte: number = 0


    @AutoMap()
    prelevement: PrelevementDTO = new PrelevementDTO()
}